import React, { useState } from "react";
import "./main-page.styles.scss";
import Toolbar from "../../components/toolbar/toolbar.component";
import SideDrawer from "../../components/side-drawer/side-drawer.component";
import StaffRoutes from "../../routes/staff.routes";
import { User } from "../../@types/user.interface";
import { GlobalState } from "../../redux/root-reducer";
import { connect } from "react-redux";
import StudentRoutes from "../../routes/student.routes";
import AdminRoutes from "../../routes/admin.routes";

interface IProps {
    user: User | null;
}

const menu = {
    admin: [
        {
            link: "/home",
            logo: "home",
            name: "Home",
        },
        {
            link: "/quiz",
            logo: "check",
            name: "Quiz",
        },
        {
            link: "/feedback",
            logo: "feedback",
            name: "Feedback",
        },
        {
            link: "/log-out",
            logo: "exit_to_app",
            name: "Log Out",
        },
        {
            link: "/course",
            logo: "check",
            name: "Course"
        }
    ],
    staff: [
        {
            link: "/home",
            logo: "home",
            name: "Home",
        },
        {
            link: "/quiz",
            logo: "check",
            name: "Quiz",
        },
        {
            link: "/feedback",
            logo: "feedback",
            name: "Feedback",
        },
        {
            link: "/course",
            logo: "import_contacts",
            name: "Course"
        },
        {
            link: "/log-out",
            logo: "exit_to_app",
            name: "Log Out",
        },
    ],
    student: [
        {
            link: "/home",
            logo: "home",
            name: "Home",
        },
        {
            link: "/quiz",
            logo: "check",
            name: "Quiz",
        },
        {
            link: "/scores",
            logo: "history",
            name: "Scores",
        },
        {
            link: "/feedback",
            logo: "feedback",
            name: "Feedback",
        },
        {
            link: "/log-out",
            logo: "exit_to_app",
            name: "Log Out",
        },
    ],
    empty: [{ link: "", logo: "", name: "" }],
};

function MainPageContainer({ user }: IProps) {
    const [sideDrawer, setSideDrawer] = useState<boolean>(false);

    const sideDrawerHandler = (status: boolean) => {
        setSideDrawer(status);
    };

    const content =
        user?.role === "Admin" ? (
            <AdminRoutes />
        ) : user?.role === "Staff" ? (
            <StaffRoutes />
        ) : user?.role === "Student" ? (
            <StudentRoutes />
        ) : (
            ""
        );

    const menus =
        user && user.role === "Admin"
            ? menu.admin
            : user && user.role === "Staff"
            ? menu.staff
            : user && user.role === "Student"
            ? menu.student
            : menu.empty;

    return (
        <div className="main-page">
            <Toolbar sideDrawerHandler={sideDrawerHandler} menus={menus} />
            <SideDrawer
                user={user}
                menus={menus}
                active={sideDrawer}
                sideDrawerHandler={sideDrawerHandler}
            />
            <div className="main-page__content">{content}</div>
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    user: { self },
}: GlobalState) => ({
    isFetching: isFetching.CHECK_USER,
    errors: errors.CHECK_USER,
    user: self.data,
});

const MainPage = connect(mapStateToProps)(MainPageContainer);

export default MainPage;
